import { EditOutlined, DeleteFilled } from "@ant-design/icons";
import { Button, Col, Pagination, Row, Space, Table, Tooltip } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotFound from "../../../../components/common/notFound";
import { SUCCESS_CODE } from "../../../../lib/const";
import FailModal from "../../../../components/modal/failModal";
import SuccessModal from "../../../../components/modal/successModal";
import ConfirmModal from "../../../../components/modal/confirmModal";

import { routes } from "../../../../routes";
import {
  deleteVisit,
  searchVisitCustomers,
} from "../../../../services/customerVisit";
import { SearchVisitContext } from "../searchContext";

const Content = ({ roleUser }) => {
  const navigate = useNavigate();
  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useContext(SearchVisitContext);
  let [no, setNo] = useState(0);
  const [dataSource, setDataSource] = useState([]);
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const fetchVisitCustomers = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchVisitCustomers(searchValues, pageValues);
      const { objectValue, pageValue } = res.data;
      if (res?.data?.code === SUCCESS_CODE) {
        let _p =
          parseInt(pageValues.page) === 0
            ? parseInt(pageValues.page)
            : parseInt(pageValues.page) * pageValues.pageSize;
        setNo(_p);
        setDataSource(objectValue);
        setPageValues(pageValue);
      } else {
        setDataSource([]);
        setPageValues((prev) => ({
          ...prev,
          page: 0,
          pageSize: 10,
          total: 0,
          totalPage: 0,
        }));
      }
    },
    [setDataSource, setSearchValues, setPageValues]
  );

  useEffect(() => {
    if (search) {
      fetchVisitCustomers(searchValues, pageValues);
      setSearch(false);
    }
  }, [fetchVisitCustomers, search]);

  const columns = [
    {
      align: "center",
      title: "ลำดับ",
      dataIndex: "no",
      width: 70,
      render: () => <span>{(no += 1)}</span>,
    },
    {
      title: "ปีงบประมาณ",
      dataIndex: "yearOfBudget",
      key: "yearOfBudget",
      width: 100,
      sorter: (a, b) => a.yearOfBudget - b.yearOfBudget,
      render: (_, record) => {
        return <>{record.yearOfBudget}</>;
      },
    },
    {
      title: "สายปฏิบัติการ",
      dataIndex: "lineOfWorkNameTh",
      key: "lineOfWork",
      width: 300,
      sorter: (a, b) => a.lineOfWork - b.lineOfWork,
      render: (_, record) => (
        <>
          <div>{record.lineOfWorkNameTh}</div>
        </>
      ),
    },
    {
      title: "นิคมอุตสาหกรรม",
      dataIndex: "estateNameTh",
      key: "estateId",
      width: 300,
      sorter: (a, b) => a.estateId - b.estateId,
      render: (_, record) => (
        <>
          <div>{record.estateNameTh}</div>
        </>
      ),
    },
    {
      title: "การจัดการ",
      dataIndex: "action",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space>
          {roleUser[0]?.isEdit && (
            <Tooltip placement="bottom" title={"แก้ไข"}>
              <Button
                className="btn-edit"
                shape="circle"
                icon={
                  <EditOutlined
                    style={{
                      color:
                        record.editable === false ? "lightgray" : "#F79009",
                    }}
                  />
                }
                onClick={() =>
                  navigate(routes.edit_customer_visit + "/" + record.id)
                }
              />
            </Tooltip>
          )}
          {roleUser[0]?.isDelete && (
            <Tooltip placement="bottom" title={"ลบ"}>
              <Button
                className="btn-delete"
                shape="circle"
                onClick={() => {
                  setConfirmModal({
                    type: "delete",
                    show: true,
                    id: record.id,
                  });
                }}
              >
                <DeleteFilled
                  style={{
                    color: record.editable === false ? "lightgray" : "#F04438",
                  }}
                />
              </Button>
            </Tooltip>
          )}
        </Space>
      ),
    },
  ];

  const onSorter = (pagination, filters, sorter) => {
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "id",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    setNo(no + pageSize);
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });

  const handleDelete = async () => {
    const res = await deleteVisit(confirmModal.id);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setSearch(true);
    } else {
      setFailModal(true);
    }
    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 2000);
    setConfirmModal({
      show: false,
      id: 0,
      type: "",
    });
  };

  return (
    <div style={{ marginTop: 20 }}>
      <p style={{ margin: "30px 0 10px 0", fontWeight: 500 }}>
        รายการทั้งหมด{" "}
        <span className="pr-purple" style={{ fontWeight: 700 }}>
          {pageValues?.total}
        </span>{" "}
        รายการ
      </p>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            scroll={{
              x: 1300,
            }}
            pagination={false}
            onChange={onSorter}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues?.page + 1 || 1}
            total={pageValues?.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>

      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDelete();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </div>
  );
};

export default Content;
